export const adPlacements = [
  {
    id: 'sidebar-top',
    name: 'Sidebar Top',
    zone: 'sidebar',
    dimensions: '300x250',
    position: 'Top of sidebar on all pages',
    price: 500,
    status: 'available',
    impressions: 0,
    clicks: 0,
    ctr: 0
  },
  {
    id: 'sidebar-middle',
    name: 'Sidebar Middle',
    zone: 'sidebar',
    dimensions: '300x250',
    position: 'Middle of sidebar on all pages',
    price: 400,
    status: 'occupied',
    impressions: 45230,
    clicks: 892,
    ctr: 1.97,
    advertiser: 'Roseville Auto Mall',
    startDate: '2025-01-15',
    endDate: '2025-02-15'
  },
  {
    id: 'header-banner',
    name: 'Header Banner',
    zone: 'header',
    dimensions: '728x90',
    position: 'Top of page below navigation',
    price: 450,
    status: 'available',
    impressions: 0,
    clicks: 0,
    ctr: 0
  },
  {
    id: 'homepage-hero',
    name: 'Homepage Hero Banner',
    zone: 'homepage',
    dimensions: '970x250',
    position: 'Below hero section on homepage',
    price: 600,
    status: 'occupied',
    impressions: 67840,
    clicks: 1523,
    ctr: 2.24,
    advertiser: 'Westfield Galleria',
    startDate: '2025-01-10',
    endDate: '2025-02-10'
  },
  {
    id: 'in-content-1',
    name: 'In-Content Ad #1',
    zone: 'content',
    dimensions: '336x280',
    position: 'Between content sections',
    price: 350,
    status: 'available',
    impressions: 0,
    clicks: 0,
    ctr: 0
  },
  {
    id: 'in-content-2',
    name: 'In-Content Ad #2',
    zone: 'content',
    dimensions: '336x280',
    position: 'Between content sections',
    price: 350,
    status: 'occupied',
    impressions: 38920,
    clicks: 734,
    ctr: 1.89,
    advertiser: 'Roseville Fitness Center',
    startDate: '2025-01-20',
    endDate: '2025-02-20'
  },
  {
    id: 'directory-top',
    name: 'Directory Listing Top',
    zone: 'directory',
    dimensions: '728x90',
    position: 'Above business listings',
    price: 400,
    status: 'available',
    impressions: 0,
    clicks: 0,
    ctr: 0
  },
  {
    id: 'directory-between',
    name: 'Directory Between Listings',
    zone: 'directory',
    dimensions: '300x250',
    position: 'Between business cards',
    price: 300,
    status: 'occupied',
    impressions: 29450,
    clicks: 512,
    ctr: 1.74,
    advertiser: 'Blue Oaks Dental',
    startDate: '2025-01-12',
    endDate: '2025-02-12'
  },
  {
    id: 'news-sidebar',
    name: 'News Sidebar',
    zone: 'news',
    dimensions: '300x600',
    position: 'Sidebar on news pages',
    price: 450,
    status: 'available',
    impressions: 0,
    clicks: 0,
    ctr: 0
  },
  {
    id: 'events-banner',
    name: 'Events Calendar Banner',
    zone: 'events',
    dimensions: '728x90',
    position: 'Above event listings',
    price: 350,
    status: 'occupied',
    impressions: 34120,
    clicks: 623,
    ctr: 1.83,
    advertiser: 'Roseville Theatre',
    startDate: '2025-01-18',
    endDate: '2025-02-18'
  },
  {
    id: 'mobile-sticky',
    name: 'Mobile Sticky Bottom',
    zone: 'mobile',
    dimensions: '320x50',
    position: 'Sticky bottom on mobile',
    price: 250,
    status: 'available',
    impressions: 0,
    clicks: 0,
    ctr: 0
  },
  {
    id: 'footer-banner',
    name: 'Footer Banner',
    zone: 'footer',
    dimensions: '728x90',
    position: 'Above footer on all pages',
    price: 200,
    status: 'available',
    impressions: 0,
    clicks: 0,
    ctr: 0
  }
];

export const adStats = {
  totalSlots: 12,
  occupiedSlots: 6,
  availableSlots: 6,
  monthlyRevenue: 2850,
  totalImpressions: 255560,
  totalClicks: 4284,
  averageCTR: 1.68,
  topPerformer: {
    name: 'Homepage Hero Banner',
    advertiser: 'Westfield Galleria',
    ctr: 2.24
  }
};

export const adCreatives = [
  {
    id: 'ad-1',
    advertiser: 'Roseville Auto Mall',
    imageUrl: 'https://public.readdy.ai/ai/img_res/043269be2a30a04eecfc8b533722245b.jpg',
    linkUrl: 'https://rosevilleautomall.com',
    altText: 'Visit Roseville Auto Mall - Premium Vehicles',
    placement: 'sidebar-middle'
  },
  {
    id: 'ad-2',
    advertiser: 'Westfield Galleria',
    imageUrl: 'https://readdy.ai/api/search-image?query=upscale%20shopping%20mall%20interior%20with%20modern%20architecture%2C%20luxury%20retail%20stores%2C%20bright%20spacious%20corridors%2C%20premium%20shopping%20center%20atmosphere%2C%20contemporary%20commercial%20design&width=970&height=250&seq=ad002&orientation=landscape',
    linkUrl: 'https://westfield.com/galleria',
    altText: 'Shop Westfield Galleria at Roseville',
    placement: 'homepage-hero'
  },
  {
    id: 'ad-3',
    advertiser: 'Roseville Fitness Center',
    imageUrl: 'https://readdy.ai/api/search-image?query=modern%20fitness%20gym%20interior%20with%20exercise%20equipment%2C%20bright%20clean%20workout%20space%2C%20professional%20fitness%20center%20atmosphere%2C%20contemporary%20gym%20design%20with%20weights%20and%20cardio%20machines&width=336&height=280&seq=ad003&orientation=portrait',
    linkUrl: 'https://rosevillefitness.com',
    altText: 'Join Roseville Fitness Center Today',
    placement: 'in-content-2'
  },
  {
    id: 'ad-4',
    advertiser: 'Blue Oaks Dental',
    imageUrl: 'https://readdy.ai/api/search-image?query=modern%20dental%20office%20interior%20with%20clean%20white%20treatment%20room%2C%20professional%20dental%20clinic%20atmosphere%2C%20contemporary%20medical%20design%2C%20bright%20welcoming%20healthcare%20environment&width=300&height=250&seq=ad004&orientation=landscape',
    linkUrl: 'https://blueoaksdental.com',
    altText: 'Blue Oaks Dental - Quality Care',
    placement: 'directory-between'
  },
  {
    id: 'ad-5',
    advertiser: 'Roseville Theatre',
    imageUrl: 'https://readdy.ai/api/search-image?query=elegant%20theatre%20stage%20with%20red%20curtains%20and%20dramatic%20lighting%2C%20classic%20performing%20arts%20venue%20interior%2C%20professional%20entertainment%20space%2C%20sophisticated%20auditorium%20atmosphere&width=728&height=90&seq=ad005&orientation=landscape',
    linkUrl: 'https://rosevilletheatre.com',
    altText: 'Roseville Theatre - Now Showing',
    placement: 'events-banner'
  }
];